import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Typography } from '@material-ui/core';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '..';
import {
  Footer,
  FormattedMessage,
  LayoutSideNavigation,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  Page,
  TermsOfService,
} from '../../components';
import { useShopConfig } from '../../hooks/shopConfig';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { Feature } from '../../util/featureFlags';
import css from './TermsOfServicePage.module.css';

const TermsOfServicePageComponent = (props) => {
  const { scrollingDisabled, intl } = props;

  const { treetShopName, customComponents } = useShopConfig();
  const isCookieConsentEnabled = useFeatureFlags(Feature.CookieConsent);

  const tabs = [
    {
      text: intl.formatMessage({ id: 'TermsOfServicePage.privacyTabTitle' }),
      selected: false,
      linkProps: {
        name: 'PrivacyPolicyPage',
      },
    },
    ...(isCookieConsentEnabled
      ? [
          {
            text: intl.formatMessage({ id: 'TermsOfServicePage.cookieTabTitle' }),
            selected: false,
            linkProps: {
              name: 'CookiePolicyPage',
            },
          },
        ]
      : []),
    {
      text: intl.formatMessage({ id: 'TermsOfServicePage.subprocessorsTabTitle' }),
      selected: false,
      linkProps: {
        name: 'SubprocessorsPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'TermsOfServicePage.tosTabTitle' }),
      selected: true,
      linkProps: {
        name: 'TermsOfServicePage',
      },
    },
  ];

  const schemaTitle = intl.formatMessage(
    { id: 'TermsOfServicePage.schemaTitle' },
    { siteTitle: treetShopName }
  );
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };
  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="TermsOfServicePage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} />
        <LayoutWrapperMain>
          <div className={css.content}>
            <h1 className={css.heading}>
              <Typography variant="h1">
                <FormattedMessage id="TermsOfServicePage.heading" />
              </Typography>
            </h1>
            {customComponents?.termsOfServiceComponent || <TermsOfService />}
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const { bool } = PropTypes;

TermsOfServicePageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = (state) => ({
  scrollingDisabled: isScrollingDisabled(state),
});

const TermsOfServicePage = compose(
  connect(mapStateToProps),
  injectIntl
)(TermsOfServicePageComponent);

export default TermsOfServicePage;
